import { useEffect } from "react"
import { loadScript } from "../utils/loadScripts"
import Footer from "./Footer"
import Header from "./Header"

function Home() {
    useEffect(() => {
        const init = async () => {
            await loadScript("/assets/js/plugins/jquery.min.js")
           // await loadScript("/assets/js/plugins/swup.min.js")
            await loadScript("/assets/js/plugins/swiper.min.js")
            await loadScript("/assets/js/plugins/fancybox.min.js")
            await loadScript("/assets/js/plugins/gsap.min.js")
            await loadScript("/assets/js/plugins/smooth-scroll.js")
            await loadScript("/assets/js/plugins/ScrollTrigger.min.js")
            await loadScript("/assets/js/plugins/ScrollTo.min.js")

            await loadScript("assets/js/main.js")
        }

        init()

    }, [])
    return (
        <>
            <div id="swup">
                                <div className="mil-preloader">
                    <div className="mil-preloader-animation">
                        <div className="mil-pos-abs mil-animation-1">
                            <p className="mil-h3 mil-muted mil-thin">Smart.</p>
                            <p className="mil-h3 mil-muted">Simple.</p>
                            <p className="mil-h3 mil-muted mil-thin">Striking</p>
                        </div>
                        <div className="mil-pos-abs mil-animation-2">
                            <div className="mil-reveal-frame">
                                <p className="mil-reveal-box"></p>
                                <p className="mil-h3 mil-muted mil-thin">black&white.agency</p>
                            </div>
                        </div>
                    </div>
                </div>

                <Header />

                {/* <!-- content --> */}
                <div className="mil-content">
                    <div id="swupMain" className="mil-main-transition">

                        {/* <!-- banner --> */}
                        <section className="mil-banner mil-dark-bg">
                            <div className="mi-invert-fix">
                                <div className="mil-animation-frame">
                                    <div className="mil-animation mil-position-1 mil-scale" data-value-1="7" data-value-2="1.6"></div>
                                    <div className="mil-animation mil-position-2 mil-scale" data-value-1="4" data-value-2="1"></div>
                                    <div className="mil-animation mil-position-3 mil-scale" data-value-1="1.2" data-value-2=".1"></div>
                                </div>
                                    <div className="container">
                                    <div className="mil-banner-content mil-up">

                                        <h1 className="mil-muted mil-mb-60">Creativity Sharpened <span className="mil-thin"><br />by Contrast & Clarity</span></h1>
                                        <div className="row">
                                            <div className="col-md-7 col-lg-8">
                                                <p className="mil-light-soft mil-mb-60">Create meaningful, strategic, and powerful communication by transforming clarity into creativity. We aim to deliver high-impact print, electronic, digital, and unsaid marketing solutions that help brands stand out, stay relevant, and make a lasting impression.</p>
                                            </div>
                                        </div>

                                        <a href="/services" className="mil-button mil-arrow-place mil-btn-space">
                                            <span>What we do</span>
                                        </a>

                                        <a href="/portfolio" className="mil-link mil-muted mil-arrow-place">
                                            <span>View works</span>
                                        </a>

                                        <div className="mil-circle-text">
                                            <svg
                                                viewBox="0 0 300 300"
                                                className="mil-ct-svg mil-rotate"
                                                data-value="360"
                                            >
                                                <defs>
                                                    <path
                                                        id="circlePath"
                                                        d="M 150,150 m -60,0 a 60,60 0 0,1 120,0 a 60,60 0 0,1 -120,0"
                                                    />
                                                </defs>

                                                <circle cx="150" cy="100" r="75" fill="none" />

                                                <g>
                                                    <use href="#circlePath" fill="none" />
                                                    <text style={{ letterSpacing: "2px", fontSize: "28px" }}>
                                                        <textPath href="#circlePath">
                                                            Scroll down - Scroll down -
                                                        </textPath>
                                                    </text>
                                                </g>
                                            </svg>
                                            <a href="#about" className="mil-button mil-arrow-place mil-icon-button mil-arrow-down"></a>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </section>
                        {/* <!-- banner end -->

                <!-- about --> */}
                        <section id="about">
                            <div className="container mil-p-120-30">
                                <div className="row justify-content-between align-items-center">
                                    <div className="col-lg-6 col-xl-5">

                                        <div className="mil-mb-90">
                                            <h3 className="mil-up mil-mb-60">Crafting <span className="mil-thin">Impact</span><br /> <span className="mil-thin">Through</span> Contrast</h3>
                                            <p className="mil-up mil-mb-30">In a world filled with noise and clutter, Black&White was born from a simple belief — clarity is the purest creativity. Based in Hyderabad, we stand for truth, contrast, and ideas that rise above distraction. We craft print, electronic, digital, and subtle unsaid marketing solutions that bring brands into sharp focus.</p>

                                            <p className="mil-up mil-mb-60">Every idea begins as a blank canvas — pure Black&White — until we shape it with purpose and imagination. We help brands communicate honestly, connect meaningfully, and create impact. Black&White isn’t just a choice — it’s a perspective.</p>

                                            <div className="mil-about-quote">
                                                <div className="mil-avatar mil-up">
                                                    <img src="/assets/img/faces/kavya-sq.jpg" alt="Founder" />
                                                </div>
                                                <h6 className="mil-quote mil-up">Passionately Creating <span className="mil-thin">Design Wonders:</span> Unleashing <span className="mil-thin">Boundless Creativity</span></h6>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-lg-5">

                                        <div className="mil-about-photo mil-mb-90">
                                            <div className="mil-lines-place"></div>
                                            <div className="mil-up mil-img-frame" style={{ paddingBottom: "160%" }}>
                                            <img src="/assets/img/photo/3,jpg" alt="img"                                             />

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </section>
                        {/* <!-- about end -->

                <!-- services --> */}
                        <section className="mil-dark-bg">
                            <div className="mi-invert-fix">
                                <div className="mil-animation-frame">
                                    <div className="mil-animation mil-position-1 mil-scale" data-value-1="2.4" data-value-2="1.4" style={{ top: "300px", right: "-100px" }}></div>
                                    <div className="mil-animation mil-position-2 mil-scale" data-value-1="2" data-value-2="1" style={{ left: "150px" }}></div>
                                </div>
                                <div className="container mil-p-120-0">

                                    <div className="mil-mb-120">
                                        <div className="row">
                                            <div className="col-lg-10">

                                                <span className="mil-suptitle mil-light-soft mil-suptitle-right mil-up">Professionals focused on helping your brand<br /> grow and move forward.</span>

                                            </div>
                                        </div>

                                        <div className="mil-complex-text mil-up mil-mb-15">

                                            <span className="mil-text-image"><img src="/assets/img/photo/2.jpg" alt="team" /></span>
                                            <h2 className="mil-h2 mil-muted mil-center"><span className="mil-thin">Where</span> Creativity<span className="mil-thin"> Meets</span></h2>
                                        </div>
                                        <div className="mil-complex-text mil-up">

                                            <h2 className="mil-h2 mil-muted mil-center">Strategic Execution</h2>
                                            <a href="/services" className="mil-services-button mil-button mil-arrow-place"><span>What we do</span></a>

                                        </div>
                                    </div>

                                    <div className="row mil-services-grid m-0">
                                        <div className="col-md-6 col-lg-3 mil-services-grid-item p-0">

                                            <a href="/services" className="mil-service-card-sm mil-up">
                                                <h5 className="mil-muted mil-mb-30">Branding & Identity Design</h5>
                                                <p className="mil-light-soft mil-mb-30">Creating impactful brand identities that express purpose, evoke emotion, and establish strong, memorable long-term market distinction.</p>
                                                <div className="mil-button mil-icon-button-sm mil-arrow-place"></div>
                                            </a>

                                        </div>
                                        <div className="col-md-6 col-lg-3 mil-services-grid-item p-0">

                                            <a href="/services" className="mil-service-card-sm mil-up">
                                                <h5 className="mil-muted mil-mb-30">Creative Advertising & Campaigns</h5>
                                                <p className="mil-light-soft mil-mb-30">Building compelling multi-channel campaigns that spark attention, drive engagement, and influence customer behaviour.</p>
                                                <div className="mil-button mil-icon-button-sm mil-arrow-place"></div>
                                            </a>

                                        </div>
                                        <div className="col-md-6 col-lg-3 mil-services-grid-item p-0">

                                            <a href="/services" className="mil-service-card-sm mil-up">
                                                <h5 className="mil-muted mil-mb-30">Digital Marketing & Performance Growth</h5>
                                                <p className="mil-light-soft mil-mb-30">Driving measurable growth through targeted digital strategies, content, and performance-focused marketing solutions.</p>
                                                <div className="mil-button mil-icon-button-sm mil-arrow-place"></div>
                                            </a>

                                        </div>
                                        <div className="col-md-6 col-lg-3 mil-services-grid-item p-0">

                                            <a href="/services" className="mil-service-card-sm mil-up">
                                                <h5 className="mil-muted mil-mb-30">Web, UI/UX & Digital Experiences</h5>
                                                <p className="mil-light-soft mil-mb-30">Designing intuitive digital experiences that enhance brand presence and convert audience interactions effectively.</p>
                                                <div className="mil-button mil-icon-button-sm mil-arrow-place"></div>
                                            </a>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        {/* <!-- services end -->

                <!-- team --> */}
                        <section>
                            <div className="container mil-p-120-30">
                                <div className="row justify-content-between align-items-center">
                                    <div className="col-lg-5 col-xl-4">

                                        <div className="mil-mb-90">
                                            <h3 className="mil-up mil-mb-60">Our <br />Core Team</h3>
                                            <p className="mil-up mil-mb-30">At the heart of b&w is a core team that blends strategic clarity with fearless creativity. Each member brings deep expertise across print, electronic, digital, and integrated marketing solutions.</p>

                                            <p className="mil-up mil-mb-60">Together, we push ideas beyond convention, shaping brand stories with sharp thinking, honest collaboration, and a commitment to delivering meaningful impact.</p>
                                            {/* 
                                    <!-- <div className="mil-up"><a href="#" className="mil-button mil-arrow-place mil-mb-60"><span>Read more</span></a></div>--> */}

                                            <h4 className="mil-up"><span className="mil-thin">Driven by </span>clarity,<br /><span className="mil-thin">defined by</span> efficiency.</h4>
                                        </div>

                                    </div>
                                    <div className="col-lg-6">

                                        <div className="mil-team-list">
                                            <div className="mil-lines-place"></div>

                                            <div className="row mil-mb-60">
                                                <div className="col-sm-6">

                                                    <div className="mil-team-card mil-up mil-mb-30">
                                                        <img src="/assets/img/faces/2.jpg" alt="Team member" />
                                                        <div className="mil-description">
                                                            <div className="mil-secrc-text">
                                                                <h5 className="mil-muted mil-mb-5"><a href="/">Chandrika Emmadi</a></h5>
                                                                <p className="mil-link mil-light-soft mil-mb-10">Founder</p>
                                                                {/* <!--    <ul className="mil-social-icons mil-center">
                                                            <li><a href="#." target="_blank" className="social-icon"> <i className="fab fa-behance"></i></a></li>
                                                            <li><a href="#." target="_blank" className="social-icon"> <i className="fab fa-dribbble"></i></a></li>
                                                            <li><a href="#." target="_blank" className="social-icon"> <i className="fab fa-twitter"></i></a></li>
                                                            <li><a href="#." target="_blank" className="social-icon"> <i className="fab fa-github"></i></a></li>
                                                        </ul> --> */}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="mil-team-card mil-up mil-mb-30">
                                                        <img src="/assets/img/faces/3.jpg" alt="Team member" />
                                                        <div className="mil-description">
                                                            <div className="mil-secrc-text">
                                                                <h5 className="mil-muted mil-mb-5"><a href="/">Hrushikesh P</a></h5>
                                                                <p className="mil-link mil-light-soft mil-mb-10">Lead Digital & Web</p>
                                                                {/* <!--    <ul className="mil-social-icons mil-center">
                                                            <li><a href="#." target="_blank" className="social-icon"> <i className="fab fa-behance"></i></a></li>
                                                            <li><a href="#." target="_blank" className="social-icon"> <i className="fab fa-dribbble"></i></a></li>
                                                            <li><a href="#." target="_blank" className="social-icon"> <i className="fab fa-twitter"></i></a></li>
                                                            <li><a href="#." target="_blank" className="social-icon"> <i className="fab fa-github"></i></a></li>
                                                        </ul> --> */}
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="col-sm-6">

                                                    <p className="mil-mobile-hidden mil-text-sm mil-mb-30" style={{ height: "30px" }}><span className="mil-accent">*</span> The masters of our agency</p>

                                                    <div className="mil-team-card mil-up mil-mb-30">
                                                        <img src="/assets/img/faces/2.jpg" alt="Team member" />
                                                        <div className="mil-description">
                                                            <div className="mil-secrc-text">
                                                                <h5 className="mil-muted mil-mb-5"><a href="/">P Dinesh VS</a></h5>
                                                                <p className="mil-link mil-light-soft mil-mb-10">Least Art & Design</p>
                                                                {/* <!--    <ul className="mil-social-icons mil-center">
                                                            <li><a href="#." target="_blank" className="social-icon"> <i className="fab fa-behance"></i></a></li>
                                                            <li><a href="#." target="_blank" className="social-icon"> <i className="fab fa-dribbble"></i></a></li>
                                                            <li><a href="#." target="_blank" className="social-icon"> <i className="fab fa-twitter"></i></a></li>
                                                            <li><a href="#." target="_blank" className="social-icon"> <i className="fab fa-github"></i></a></li>
                                                        </ul> --> */}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="mil-team-card mil-up mil-mb-30">
                                                        <img src="/assets/img/faces/4.jpg" alt="Team member" />
                                                        <div className="mil-description">
                                                            <div className="mil-secrc-text">
                                                                <h5 className="mil-muted mil-mb-5"><a href="/">Pooja Rani</a></h5>
                                                                <p className="mil-link mil-light-soft mil-mb-10">Lead creative & Design</p>
                                                                {/* <!--    <ul className="mil-social-icons mil-center">
                                                            <li><a href="#." target="_blank" className="social-icon"> <i className="fab fa-behance"></i></a></li>
                                                            <li><a href="#." target="_blank" className="social-icon"> <i className="fab fa-dribbble"></i></a></li>
                                                            <li><a href="#." target="_blank" className="social-icon"> <i className="fab fa-twitter"></i></a></li>
                                                            <li><a href="#." target="_blank" className="social-icon"> <i className="fab fa-github"></i></a></li>
                                                        </ul> --> */}
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </section>
                        {/* <!-- team end -->

                <!-- reviews --> */}
                        <section className="mil-soft-bg">
                            <div className="container mil-p-120-120">

                                <div className="row">
                                    <div className="col-lg-10">

                                        <span className="mil-suptitle mil-suptitle-right mil-suptitle-dark mil-up">Customer reviews are a valuable source <br />of information for both businesses and consumers.</span>

                                    </div>
                                </div>

                                <h2 className="mil-center mil-up mil-mb-60">Hear <span className="mil-thin">what </span> <br />Our Clients <span className="mil-thin">want to Say!</span></h2>

                                <div className="mil-revi-pagination mil-up mil-mb-60"></div>

                                <div className="row mil-relative justify-content-center">
                                    <div className="col-lg-8">

                                        <div className="mil-slider-nav mil-soft mil-reviews-nav mil-up">
                                            <div className="mil-slider-arrow mil-prev mil-revi-prev mil-arrow-place"></div>
                                            <div className="mil-slider-arrow mil-revi-next mil-arrow-place"></div>
                                        </div>

                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" className="mil-quote-icon mil-up">
                                            <path d="M 13.5 10 A 8.5 8.5 0 0 0 13.5 27 A 8.5 8.5 0 0 0 18.291016 25.519531 C 17.422273 29.222843 15.877848 31.803343 14.357422 33.589844 C 12.068414 36.279429 9.9433594 37.107422 9.9433594 37.107422 A 1.50015 1.50015 0 1 0 11.056641 39.892578 C 11.056641 39.892578 13.931586 38.720571 16.642578 35.535156 C 19.35357 32.349741 22 27.072581 22 19 A 1.50015 1.50015 0 0 0 21.984375 18.78125 A 8.5 8.5 0 0 0 13.5 10 z M 34.5 10 A 8.5 8.5 0 0 0 34.5 27 A 8.5 8.5 0 0 0 39.291016 25.519531 C 38.422273 29.222843 36.877848 31.803343 35.357422 33.589844 C 33.068414 36.279429 30.943359 37.107422 30.943359 37.107422 A 1.50015 1.50015 0 1 0 32.056641 39.892578 C 32.056641 39.892578 34.931586 38.720571 37.642578 35.535156 C 40.35357 32.349741 43 27.072581 43 19 A 1.50015 1.50015 0 0 0 42.984375 18.78125 A 8.5 8.5 0 0 0 34.5 10 z" fill="#000000" />
                                        </svg>

                                        <div className="swiper-container mil-reviews-slider">
                                            <div className="swiper-wrapper">
                                                <div className="swiper-slide">
                                                    <div className="mil-review-frame mil-center" data-swiper-parallax="-200" data-swiper-parallax-opacity="0">
                                                        <h5 className="mil-up mil-mb-10">Manish Chelimala </h5>
                                                        <p className="mil-mb-5 mil-upper mil-up mil-mb-30">Founder, Bhoomi Kitchens </p>
                                                        <p className="mil-text-xl mil-up">Balck&White understood our vision and translate it into a brand that feels warm, authetic, and rooted. From identity to communication, their strategic thinking helped Bhoomi connect emotionally with customers and stand out in a competitve foood space.</p>
                                                    </div>
                                                </div>
                                                <div className="swiper-slide">
                                                    <div className="mil-review-frame mil-center" data-swiper-parallax="-200" data-swiper-parallax-opacity="0">
                                                        <h5 className="mil-up mil-mb-10">Arjun Reddy Vangeti </h5>
                                                        <p className="mil-mb-5 mil-upper mil-up mil-mb-30">Founder, Bhonam Kitchens </p>
                                                        <p className="mil-text-xl mil-up">The team at Black&White brought clarity and creativity to Bhonam's brand. Their thoughtful apprach to design and storytelling helped us create a strong presence that truly reflects our culinary philosophy and local appeal.</p>
                                                    </div>
                                                </div>
                                                <div className="swiper-slide">
                                                    <div className="mil-review-frame mil-center" data-swiper-parallax="-200" data-swiper-parallax-opacity="0">
                                                        <h5 className="mil-up mil-mb-10">Arun Reddy B</h5>
                                                        <p className="mil-mb-5 mil-upper mil-up mil-mb-30">Founder, Zimbomo Sprint Safe </p>
                                                        <p className="mil-text-xl mil-up">Blach&White played a key role in shaping Zimbomo's futuristic identy. Their branding and communication made our smart locker concept easy to understand, credible, and appealing acrss public infrastructure and urban audiences.</p>
                                                    </div>
                                                </div>
                                                <div className="swiper-slide">
                                                    <div className="mil-review-frame mil-center" data-swiper-parallax="-200" data-swiper-parallax-opacity="0">
                                                        <h5 className="mil-up mil-mb-10">Dr. Neela Srinivas</h5>
                                                        <p className="mil-mb-5 mil-upper mil-up mil-mb-30">Founder, WellCare Clinics </p>
                                                        <p className="mil-text-xl mil-up">From visuals to messaging, Black&White gave WellCare a professional yet friendly brand image. Their work helped buid patient trust,improve recall, and present our clinic as modern, reliable, and patient-focused.</p>
                                                    </div>
                                                </div>
                                                <div className="swiper-slide">
                                                    <div className="mil-review-frame mil-center" data-swiper-parallax="-200" data-swiper-parallax-opacity="0">
                                                        <h5 className="mil-up mil-mb-10">Dr. Srinivas </h5>
                                                        <p className="mil-mb-5 mil-upper mil-up mil-mb-30">Founder, 32Dentistry</p>
                                                        <p className="mil-text-xl mil-up">Black&White helped us simplify a complex digital healthcare platfrom into a clean, user-friendly brand. Their UI, branding, and communication strategy played a crucial role in making 32Dentistry approachable for clinics and denstists alike.</p>
                                                    </div>
                                                </div>
                                                <div className="swiper-slide">
                                                    <div className="mil-review-frame mil-center" data-swiper-parallax="-200" data-swiper-parallax-opacity="0">
                                                        <h5 className="mil-up mil-mb-10">Ramesh K</h5>
                                                        <p className="mil-mb-5 mil-upper mil-up mil-mb-30">Founder, Aquadhara</p>
                                                        <p className="mil-text-xl mil-up">The branding by Black&White gave Aquadhara a fresh,trustworthy, and premium identity.Their design approach communicated purity and reliability, helping us stengthen our market presence and connect confidently with distributors and consumers.</p>
                                                    </div>
                                                </div>
                                                <div className="swiper-slide">
                                                    <div className="mil-review-frame mil-center" data-swiper-parallax="-200" data-swiper-parallax-opacity="0">
                                                        <h5 className="mil-up mil-mb-10">Bobbal Arun </h5>
                                                        <p className="mil-mb-5 mil-upper mil-up mil-mb-30">Founder, Cocoe Tinder Coconut </p>
                                                        <p className="mil-text-xl mil-up">Black&White crafted a vibrant and refreshing brand for Cocoe that prefectly reflects natural goodness. Their strategic branding helped us position tender coconut as a modern, lifestyle- focused product with strong shelf and digital appeal.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </section>
                        {/* <!-- reviews end -->

                <!-- partners --> */}
                        <div className="mil-soft-bg">
                            <div className="container mil-p-0-120">

                                <div className="swiper-container mil-infinite-show mil-up">
                                    <div className="swiper-wrapper">
                                        <div className="swiper-slide">
                                            <a href="https://32dentistry.in" className="mil-partner-frame" style={{ width: "210px" }}><img src="/assets/img/partners/32 Dentistry.svg" alt="logo" /></a>
                                        </div>
                                        <div className="swiper-slide">
                                            <a href="#." className="mil-partner-frame" style={{ width: "210px" }}><img src="/assets/img/partners/Bhonam.svg" alt="logo" /></a>
                                        </div>
                                        <div className="swiper-slide">
                                            <a href="#." className="mil-partner-frame" style={{ width: "210px" }}><img src="/assets/img/partners/Bhoomi.svg" alt="logo" /></a>
                                        </div>
                                        <div className="swiper-slide">
                                            <a href="https://dawath.in" className="mil-partner-frame" style={{ width: "210px" }}><img src="/assets/img/partners/Dawath.svg" alt="logo" /></a>
                                        </div>
                                        <div className="swiper-slide">
                                            <a href="https://zibomo.ooo" className="mil-partner-frame" style={{ width: "210px" }}><img src="/assets/img/partners/zibomo.svg" alt="logo" /></a>
                                        </div>
                                        <div className="swiper-slide">
                                            <a href="#." className="mil-partner-frame" style={{ width: "210px" }}><img src="/assets/img/partners/Aquadhara.svg" alt="logo" /></a>
                                        </div>
                                        <div className="swiper-slide">
                                            <a href="https://www.wellcare.in" className="mil-partner-frame" style={{ width: "210px" }}><img src="/assets/img/partners/Wellcare.svg" alt="logo" /></a>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        {/* <!-- partners end -->

                <!-- blog --> */}
                        <section>
                            <div className="container mil-p-120-60">
                                <div className="row align-items-center mil-mb-30">
                                    <div className="col-lg-6 mil-mb-30">
                                        <h3 className="mil-up">Popular Publications:</h3>
                                    </div>
                                    <div className="col-lg-6 mil-mb-30">
                                        <div className="mil-adaptive-right mil-up">
                                            <a href="/blog" className="mil-link mil-dark mil-arrow-place">
                                                <span>View all</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-4">
                                        <a href="/blog" className="mil-blog-card mil-mb-60">
                                            <div className="mil-cover-frame mil-up">
                                                <img src="/assets/img/blog/1.jpg" alt="cover" />
                                            </div>
                                            <div className="mil-post-descr">
                                                <div className="mil-labels mil-up mil-mb-30">                                                    
                                                <div className="mil-label mil-normal">19 February 2026</div>
                                                </div>
                                                <h5 className="mil-up mil-mb-30">Branding Beyond Logos: Building Meaning Brand Experiences</h5>
                                                <p className="mil-post-text mil-up mil-mb-30">Branding today goes far beyond a logo or colour palette. In a world filled with choices,...</p>
                                                <div className="mil-link mil-dark mil-arrow-place mil-up">
                                                    <span>Read more</span>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                    <div className="col-lg-4">
                                        <a href="/blog" className="mil-blog-card mil-mb-60">
                                            <div className="mil-cover-frame mil-up">
                                                <img src="/assets/img/blog/1.jpg" alt="cover" />
                                            </div>
                                            <div className="mil-post-descr">
                                                <div className="mil-labels mil-up mil-mb-30">                        
                                                <div className="mil-label mil-normal">05 February 2026</div>
                                                </div>
                                                <h5 className="mil-up mil-mb-30">Branding Lessons Every Grwoing Business Should Learn</h5>
                                                <p className="mil-post-text mil-up mil-mb-30">As business grow, branding often takes a backseat to sales targets, operations and..</p>
                                                <div className="mil-link mil-dark mil-arrow-place mil-up">
                                                    <span>Read more</span>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                    <div className="col-lg-4">
                                        <a href="/blog" className="mil-blog-card mil-mb-60">
                                            <div className="mil-cover-frame mil-up">
                                                <img src="/assets/img/blog/2.jpg" alt="cover" />
                                            </div>
                                            <div className="mil-post-descr">
                                                <div className="mil-labels mil-up mil-mb-30">
                                                    <div className="mil-label mil-normal">22 January 2026</div>
                                                </div>
                                                <h5 className="mil-up mil-mb-30">Common UI/UX Mistakes Brands Still Make</h5>
                                                <p className="mil-post-text mil-up mil-mb-30">In a digital-first worl, a brand's website or app ofter becomes the first-and sometimes only-interaction a customer has with the business. While design trends evolve and tools.</p>
                                                <div className="mil-link mil-dark mil-arrow-place mil-up">
                                                    <span>Read more</span>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <Footer />

                    </div>
                </div>
            </div>

        </>
    )
}

export default Home